import Vue from 'vue';

Vue.use({
  install() {
    Vue.prototype.$generateAssetsUrl = function(url: string): URL {
      return new URL(url, process.env.VUE_APP_BASE_ASSETS_URL);
    };
  }
});
